/**
 * Narrator Reactions Module
 *
 * Live narrator text that cross-fades during the rewrite session.
 * Curated client-side strings (not LLM calls) for real-time feedback.
 */

export type {
  ReactionTrigger,
  EnergyLevel,
  VoiceTier,
  SeverityBucket,
  CrossingTarget,
  Reaction,
  ReactionContext,
} from './types';

export { selectReaction, getEnergyFromDelta } from './selectReaction';

export {
  useNarratorReactions,
  type UseNarratorReactionsOptions,
  type UseNarratorReactionsReturn,
} from './useNarratorReactions';

export {
  ACCEPT_REACTIONS,
  CROSSING_REACTIONS,
  LOADING_REACTIONS,
  RESCORE_RESULT_REACTIONS,
  RESCORE_FAILURE_REACTIONS,
  COMPLETE_REACTIONS,
} from './reaction-banks';
